import React from 'react';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import logo from '../Images/logo.png'


const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <div className='footer-section'>
            <div className="container">
                <div className="footer-section-cont">
                    <div className="footer-links">
                        <h4>Factory</h4>
                        <p>
                            R-12, SIPCOT Industrial Growth Center,<br />
                            Perundurai - 638052,<br />
                            Erode - District,<br />
                            Tamil Nadu,<br />
                            India.
                        </p>

                    </div>
                    <div className="footer-links">
                        {/* <h4>Quick Links</h4>
                        <Nav className="flex-column footer-section">
                            <Nav.Link as={Link} to="/">Home</Nav.Link>
                            <Nav.Link as={Link} to="/about">About Us</Nav.Link>
                            <Nav.Link as={Link} to="/services">Services</Nav.Link>
                            <Nav.Link as={Link} to="/infrastructure">Infrastructure</Nav.Link>
                            <Nav.Link as={Link} to="/quality">Quality</Nav.Link>
                            <Nav.Link as={Link} to="/contact">Contact Us</Nav.Link>
                        </Nav> */}
                        <h4>Reach Us</h4>
                        <p>
                            <p>
                                <a href="mailto:info@shivasakthifashions.com">info@shivasakthifashions.com</a><br />
                                <a href="tel:+91-4294-234147">+91-4294-234147</a>
                            </p>
                        </p>
                    </div>

                    <div className="footer-links">
                        <div className="footer-logo">
                            <img src={logo} alt="logo" />
                        </div>
                    </div>
                </div>
                <div className="copy-right-section">
                    <div className="copy-right-left">
                    <p> &copy; {currentYear} Shivasakthi Fashions. All rights reserved.</p>
                    </div>
                    <div className="designed-by">
                    <p>Designed By <a href="https://www.byzerotechnologies.com/">Byzero Technologies</a></p>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Footer;